(function () {
    'use strict';

    AntiForgeryTokenInterceptor.$inject = [
        'antiForgeryService',
        'corsWithCredential'
    ];

    function AntiForgeryTokenInterceptor(antiForgeryService, corsWithCredential) {
        return {
            request: function (config) {
                if (!corsWithCredential) return config;

                var token = antiForgeryService.getToken();
                config.headers['X-XSRF-TOKEN'] = token;
                return config;
            }
        };
    }

    module.exports = AntiForgeryTokenInterceptor;

})();